import cacheLs from "../cacheLs"

export default {
  setNotification (state, data) {
    state.notification = JSON.stringify(data)
    cacheLs.set_notification(data)
  }
}
